<template>
    <div>
        <div class="search-box">
            <!-- <p>学年：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.schoolYear" />
            </a-date-picker>
            <p>学期：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.semester" >
                <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                <a-select-option  :value="(year-0+1)+'D'">夏季学期</a-select-option>
            </a-select> -->
            <p>课程名：</p>
            <a-input class="input-box" v-model="searchFrom.courseName" />
            <p>课程号：</p>
            <a-input class="input-box" v-model="searchFrom.courseCode" />
            <p>中英文：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.languageName" >
                <a-select-option  value="中文">中文</a-select-option>
                <a-select-option  value="英文">英文</a-select-option>
            </a-select>
            <a-button type="primary" icon="search"  @click="searchList">搜索</a-button>
            
        </div>
        <div class="operation-box">
            <a-button 
                type="primary" 
                icon="plus" 
                class="btn"
                v-if="permissions.indexOf('undergraduate:culture:courseProgram:add')>-1" 
                @click="$router.push('/admin/undergraduate/culture/syllabusAndBooks/info?type=add')">
                 指定负责人
            </a-button>
            <a-button
                v-if="permissions.indexOf('undergraduate:culture:courseProgram:edit')>-1 || permissions.indexOf('undergraduate:culture:courseProgram:query')>-1"
                type="primary" 
                icon="edit" 
                class="btn"
                @click="sub('edit')">
                 管理负责人
            </a-button>
            <a-button 
                v-if="permissions.indexOf('undergraduate:culture:textBook:add')>-1" 
                type="primary" 
                icon="plus" 
                class="btn"
                @click="sub('addBook')">
                 新增
            </a-button>
            <a-button 
                v-if="permissions.indexOf('undergraduate:culture:textBook:add')>-1" 
                type="primary" 
                icon="edit" 
                class="btn"
                @click="sub('editBook')" :disabled='editDisable'>
                 编辑
            </a-button>
            <a-button 
                v-if="permissions.indexOf('undergraduate:culture:textBook:add')>-1" 
                type="primary" 
                icon="book" 
                class="btn"
                @click="sub('lookBook')">
                 查看详情
            </a-button>
            <a-button 
                v-if="permissions.indexOf('undergraduate:culture:textBook:add')>-1" 
                type="primary" 
                icon="check" 
                class="btn"
                @click="sub('approve')">
                 审批
            </a-button>
        </div>
        <a-table 
            rowKey='id'
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :customRow="onClickRow"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>
    </div>
</template>
<script>
    import { list,del } from '@/baseAPI/undergraduate/culture/syllabus'
    import { getSchoolYear,getSemester } from '@/baseAPI/util'
    const columns = [
        {
            title: '序号',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '课程号',
            dataIndex: 'courseCode',
            align:'center'
        },
        {
            title: '课程名称',
            dataIndex: 'courseName',
            align:'center',
        },
        {
            title: '中/英文',
            dataIndex: 'languageName',
            align:'center'
        },
        {
            title: '负责人',
            dataIndex: 'teacherName',
            align:'center'
        },
        {
            title: '课程所属部门',
            dataIndex: 'orgName',
            align:'center'
        },
        {
            title: '教材名称',
            dataIndex: 'bookName',
            align:'center'
        },
        {
            title: '提交时间',
            dataIndex: 'commitTime',
            align:'center'
        },
        {
            title: '审批时间',
            dataIndex: 'approveTime',
            align:'center'
        },
        // ,
        // {
        //     title: '状态',
        //     dataIndex: 'approvalStatus',
        //     align:'center',
        //     customRender: (text) => {
        //         if(text=='reject'){
        //             return { children: '已驳回'};
        //         }else if(text=='approved'){
        //             return { children: '系主任已审批'};
        //         }else if(text=='commit'){
        //             return { children: '未审批'};
        //         }else{
        //             return { children: '未提交'};
        //         }
        //     },
        // }

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    courseName:'',
                    courseCode:'',
                    approvalStatus:'',
                    schoolYear:'',
                    semester:'',
                    languageName:''
                },
                permissions:[],
                year:'',
                yearShowOne:false,
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'},
                selectedRowKeys: [],
                bookInfo:{
                    id:null,
                    courseProgramId:null,
                    name:null,
                    author:null,
                    press:null,
                    publishDate:null,
                    isbn:null,
                    edition:null,
                    isMarx:null,
                    isStateLevel:null,
                    isAllEnglish:null,
                    coverFile:null,
                    schoolYear:null,
                    semester:null,
                    courseNo:null,
                    languageName:null,
                    coverFile:null,
                    files:null,
                    approvalStatus:null
                },
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                editDisable:false
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            console.log(this.permissions)
            if(typeof this.$route.query.courseCode!='undefined'){
                this.searchFrom.courseName=this.$route.query.courseName;
                this.searchFrom.courseCode=this.$route.query.courseCode;
            }
            this.searchFrom.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            this.searchFrom.semester=getSemester()
            this.fetch()
        },
        methods:{
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                this.data.forEach(e=>{
                    if(e.id == this.selectedRowKeys[0] && (e.commitTime == null || e.commitTime == '')){
                        this.editDisable = true;
                    }else if(e.id == this.selectedRowKeys[0] && e.commitTime != null && e.commitTime != ''){
                        this.editDisable = false;
                    }
                })
                console.log(selectedRowKeys)
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.searchFrom.semester='';
                this.yearShowOne = false;
            },
            handleTableChange(pagination){
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(){
                if(this.selectedRowKeys.length > 0){
                    del(this.selectedRowKeys[0]).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'删除课程大纲成功',
                            });
                            this.fetch()
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择记录后再删除',
                    });
                }
            },
            sub(type){
                if(type == 'approve'){
                    if(this.selectedRowKeys.length > 0){
                        this.$router.push('/admin/undergraduate/culture/syllabusAndBooks/info?type=approve&&id='+this.selectedRowKeys[0]);
                    }else{
                        this.$notification['info']({
                        message: '提示',
                        description:'请选择记录后再进行审批',
                    });
                    }
                }else if(type == 'addBook'){
                    if(this.selectedRowKeys.length > 0){
                        this.$router.push('/admin/undergraduate/culture/syllabusAndBooks/info?type=addBook&&id='+this.selectedRowKeys[0]);
                    }else{
                        this.$notification['info']({
                        message: '提示',
                        description:'请选择记录后再进行新增',
                    });
                    }
                }else if(type == 'editBook'){
                    if(this.selectedRowKeys.length > 0){
                        this.$router.push('/admin/undergraduate/culture/syllabusAndBooks/info?type=editBook&&id='+this.selectedRowKeys[0]);
                    }else{
                        this.$notification['info']({
                        message: '提示',
                        description:'请选择记录后再进行编辑',
                    });
                    }
                }else if(type == 'lookBook'){
                    if(this.selectedRowKeys.length > 0){
                        this.$router.push('/admin/undergraduate/culture/syllabusAndBooks/info?type=lookBook&&id='+this.selectedRowKeys[0]);
                    }else{
                        this.$notification['info']({
                        message: '提示',
                        description:'请选择记录后再进行查看详情',
                    });
                    }
                }else if(type == 'edit'){
                    if(this.selectedRowKeys.length > 0){
                        this.$router.push('/admin/undergraduate/culture/syllabusAndBooks/info?type=edit&&id='+this.selectedRowKeys[0]);
                    }else{
                        this.$notification['info']({
                        message: '提示',
                        description:'请选择记录后再进行管理',
                    });
                    }
                }else if(type == 'look'){
                    if(this.selectedRowKeys.length > 0){
                        this.$router.push('/admin/undergraduate/culture/syllabusAndBooks/info?type=look&&id='+this.selectedRowKeys[0]);
                    }else{
                        this.$notification['info']({
                        message: '提示',
                        description:'请选择记录后再进行查看',
                    });
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }

    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
</style>
